export default __webpack_public_path__ + "static/media/rotatedevice.307a20d0.gif";